/* Generated code; Use nx run packages/systems/ui/icons:generate-icons
  * to regenerate this file.
  */
import React, {SVGProps} from 'react';
import type { IconProps } from '@packages/utilities/icon-support';
const createElement = React.createElement;
export default /*#__PURE__#*/ function FieldColorSmall(props: IconProps): React.ReactElement<SVGProps<SVGElement>> {
  const inputScale = props.scale ?? 1;
  const scale = typeof inputScale === 'number' ? inputScale : parseInt(inputScale, 10);
  return createElement('svg', {
      'data-icon': 'FieldColorSmall',
      'aria-hidden': true,
      focusable: false,
      width:  14 * scale,
      height: 15 * scale,
      viewBox: '0 0 14 15',
      y: props.y != null ? props.y : undefined,
      x: props.x != null ? props.x : undefined,
      className: 'bem-Svg' + (props.className ? ' ' + props.className : ''),
      style: {...{
        display: 'block',
      }, ...props.style}
    },createElement('path', {"fill":"currentColor","d":"M10.94 1S9.598 3.514 9.185 4.697a1.7 1.7 0 0 0-.076.5v.066c0 .96.82 1.737 1.836 1.737 1.013 0 1.838-.778 1.838-1.737l-.002-.034.002-.037c0-.18-.047-.373-.047-.373-.26-1-1.797-3.82-1.797-3.82zM4.973 1S2.06 6.447 1.166 9.01C1.058 9.313 1 9.755 1 10.093l.006.048-.006.1C1 12.316 2.783 14 4.982 14c2.195 0 3.982-1.685 3.982-3.763l-.004-.074.004-.07c0-.39-.1-.808-.1-.808C8.296 7.113 4.97 1 4.97 1zm.01 11c-1.073 0-1.95-.763-1.98-1.71l.004-.046v-.105l-.002-.15c.008-.13.03-.264.05-.323.38-1.09 1.176-2.788 1.93-4.314.896 1.794 1.72 3.578 1.932 4.387l.046.3-.002.027v.093l.007.126c-.03.95-.908 1.712-1.982 1.712z"}))
}
